import React from "react";
import { useTranslation } from "react-i18next";
import { Upload, UserCheck, FileText, MessageCircle } from "lucide-react";

export function HowItWorksGuide() {
  const { t } = useTranslation();

  const steps = [
    {
      title: t("howItWorks.submitCase"),
      description: t("howItWorks.uploadReports"),
      icon: <Upload size={28} />,
    },
    {
      title: t("howItWorks.expertReview"),
      description: t("howItWorks.specialistAnalyzesInfo"),
      icon: <UserCheck size={28} />,
    },
    {
      title: t("howItWorks.getReport"),
      description: t("howItWorks.receiveDetailedOpinion"),
      icon: <FileText size={28} />,
    },
    {
      title: t("howItWorks.followUp"),
      description: t("howItWorks.askQuestions"),
      icon: <MessageCircle size={28} />,
    },
  ];

  // const [darkMode, setDarkMode] = React.useState(
  //   () =>
  //     typeof document !== 'undefined' &&
  //     document.body.getAttribute('data-bs-theme') === 'dark'
  // );

  // React.useEffect(() => {
  //   if (typeof document === 'undefined') return;

  //   const update = () =>
  //     setDarkMode(document.body.getAttribute('data-bs-theme') === 'dark');

  //   const observer = new MutationObserver(update);
  //   observer.observe(document.body, {
  //     attributes: true,
  //     attributeFilter: ['data-bs-theme'],
  //   });

  //   update();

  //   return () => observer.disconnect();
  // }, []);

  return (
    <>
      <div className="text-center mb-5">
        <h2 className="mb-2">{t("howItWorks.title")}</h2>
        <p className="text-muted">{t("howItWorks.subtitle")}</p>
      </div>

      <div className="row g-4 mb-4">
        {steps.map((step, index) => (
          <div key={index} className="col-12 col-md-6">
            <div className="card border-0 h-100 shadow">
              <div
                className="rounded-circle position-absolute  d-flex align-items-center justify-content-center"
                style={{
                  width: 40,
                  height: 40,
                  top: 4,
                  left: 4,
                }}
              >
                <span
                  className="bg-body border border-2 rounded-circle text-center fw-bold align-middle d-flex justify-content-center align-items-center"
                  style={{
                    width: 25,
                    height: 25,
                    fontSize: 14,
                    lineHeight: 1,
                  }}
                >
                  {index + 1}
                </span>
              </div>
              <div className="card-body text-center d-flex flex-column align-items-center">
                <div
                  className="mb-3 p-3 rounded-circle text-white"
                  style={{
                    background: "linear-gradient(to right, #23B3D3, #007C89)",
                  }}
                >
                  {step.icon}
                </div>

                <h5 className="card-title ">{step.title}</h5>
                <p className="card-text text-muted">{step.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="alert alert-info text-center d-flex align-items-center justify-content-center gap-2 small">
        <div
          className="rounded-circle bg-primary"
          style={{ width: 8, height: 8 }}
        ></div>
        <span>{t("howItWorks.securityNote")}</span>
      </div>
    </>
  );
}
